import React, { useState, useEffect } from "react";
import Timer from "./timer-component";

function StopWatch(props) {
    const [isActive, setIsActive] = useState(false);
    const [isPaused, setIsPaused] = useState(true);
    const [quizStarted, setQuizStarted] = useState(props.quizStarted)
    const [timerOn, setTimerOn] = useState(props.timerOn)
    const [time, setTime] = useState(0);

    if (props.quizStarted !== quizStarted || props.timerOn !== timerOn) {
        setTimerOn(props.timerOn);
        setQuizStarted(props.quizStarted);
        
    }

    useEffect(() => {
        if (quizStarted && !timerOn) {
            setIsActive(true);
            setIsPaused(!isPaused);
        }
        if (quizStarted && timerOn) {
            setIsActive(true);
            setIsPaused(!isPaused);
        }
        if (!quizStarted && !timerOn) {
            setIsActive(false);
            setTime(0);
        }
    }, [timerOn, quizStarted])

    useEffect(() => {
        let interval = null;

        if (isActive && isPaused === false) {
            interval = setInterval(() => {
                setTime((time) => time + 10);
            }, 10);
        } else {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval);
        };
    }, [isActive, isPaused]);
    return (
        <div className="stop-watch">
            {props.quizStarted &&
                <Timer time={time} />
            }
        </div>
    );
}

export default StopWatch;